module.exports = __webpack_public_path__ + "static/logo2b-c0452687ffb84cc1f6bdb7eacc93268f.png";